module.exports = __webpack_public_path__ + "static/media/bannerArredamento2.8a23d241.png";